import { post } from 'utils';

export default function resetPassword(
  params = {},
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {}
) {
  post({ apiKey: 'auth.resetPassword', noTokenRequired: true }, { params })
    .then(({ data }) => onSuccess(data))
    .catch(onError)
    .finally(onFinally);
}
